import { Star } from 'lucide-react';
import { Card, CardContent, CardHeader } from './ui/card';

const ReviewCard = ({ review }) => {
  return (
    <Card className="h-full hover:shadow-lg transition-shadow">
      <CardHeader>
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-semibold text-lg">{review.name}</h3>
            <p className="text-sm text-gray-500">{review.date}</p>
          </div>
          <div className="flex">
            {[...Array(review.rating)].map((_, i) => (
              <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <h4 className="font-medium text-blue-600 mb-2">{review.title}</h4>
        <p className="text-sm text-gray-600 mb-3">{review.vehicle}</p>
        <p className="text-sm text-gray-700 line-clamp-4">{review.text}</p>
        {review.productImage && (
          <img
            src={review.productImage}
            alt="Product"
            className="w-24 h-24 object-contain mt-3"
          />
        )}
      </CardContent>
    </Card>
  );
};

export default ReviewCard;
